import Vue from 'vue'
import VueRouter from 'vue-router'
// import {newImport} from "@/utils/common";
import allRoutes from "@/router/routes";
Vue.use(VueRouter)

export const baseRoute = [
    {
        path: '/',
        name: 'Home',
        redirect: '/welcome',
        component: () => import('@/views/Home'),
        children: [
            {
                path: '/welcome',
                name: 'welcome',
                component: () => import('@/views/welcome'),
                meta: {
                    name: "欢迎光临",
                    isMenu: true,
                    keepAlive: false
                }
            },
            ...allRoutes,
            {
                path: '/test',
                name: 'test',
                component: () => import('@/views/test/index'),
                meta: {
                    name: "测试页",
                    isMenu: true,
                    keepAlive: true
                }
            }
        ]
    },
    {
        path: '/auth',
        name: 'Auth',
        component: () => import('@/views/auth'),
    },
    {
        path: '/overseas/*',
        name: 'overseas',
        component: () => import('@/views/NotFound'),
    },
    
    {
        path: '*',
        name: '404',
        component: () => import('@/views/NotFound'),
    }
]

// 解决重复路由报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
    mode: 'history',
    base: '/',
    routes: baseRoute
})

export default router
